import React from 'react';

import Reveal, { SectionTitle } from './Reveal';

const USER = 'harshit1142';

const TROPHY = `https://github-profile-trophy.vercel.app/?username=${USER}&margin-w=10&no-frame=true&row=2&theme=discord`;
const STATS = `https://github-profile-summary-cards.vercel.app/api/cards/stats?username=${USER}&theme=github_dark`;
const LANGS = `https://github-profile-summary-cards.vercel.app/api/cards/most-commit-language?username=${USER}&theme=github_dark`;
const HOLOPIN = `https://holopin.me/${USER}`;

function StatImg({ src, alt, style, onFail }) {
  const [failed, setFailed] = React.useState(false);

  const fail = React.useCallback(() => {
    setFailed(true);
    if (onFail) onFail();
  }, [onFail]);

  if (failed) return null;

  return (
    <img
      src={src}
      alt={alt}
      loading="lazy"
      style={style}
      onLoad={(e) => {
        if (!e.currentTarget.naturalWidth) fail();
      }}
      onError={fail}
    />
  );
}

export default function GithubStats() {
  const [rowFailed, setRowFailed] = React.useState(0);
  const onRowFail = React.useCallback(() => setRowFailed((n) => n + 1), []);

  return (
    <section className="section" id="github">
      <SectionTitle
        eyebrow="Activity"
        title="GitHub Stats"
        subtitle="Contribution history, language mix, and open-source badges."
      />

      <Reveal>
        <div className="gh-wrap">
          <StatImg src={TROPHY} alt="GitHub trophies" />

          {rowFailed < 2 && (
            <div className="gh-row">
              <StatImg src={STATS} alt="GitHub stats summary" onFail={onRowFail} />
              <StatImg src={LANGS} alt="Most committed languages" onFail={onRowFail} />
            </div>
          )}

          <StatImg src={HOLOPIN} alt="Holopin badges" style={{ width: '100%' }} />
        </div>
      </Reveal>
    </section>
  );
}
